/* eslint-disable no-useless-escape */
import MiloObject from '../../common/object';
import Cookie from '../../common/cookie';
import miloUrl from '../../common/url';
import { g, isDom, isObject } from '../../common/base'; // 存储xhrPostKey对应关系

var xhrPostKeyCache = {
  /* key:flow*/
}; // 获取唯一的xhrPostKey

var getXhrPostKey = function getXhrPostKey() {
  var key = "xhr_".concat(new Date().getTime()).concat(Math.ceil(100 * Math.random()));

  while (xhrPostKeyCache[key]) {
    key = "xhr_".concat(new Date().getTime()).concat(Math.ceil(100 * Math.random()));
  }

  return key;
};
/*
    一个页面多个活动id，可能存在多个域名的ame请求，
    为了避免此问题，需要为每一个域名建立一个iframe通信机制
    add by marsboyding
    ============Start==========
*/
// 域名列表


var domainList = {}; // Post 数据队列

var xhrPostQueue = []; // Post sUrl队列

var xhrPostUrlQueue = []; // Post 环境ok

var xhrPostCondition = false; // Post 对应关系

var xhrPostRelation = {}; // 通过url获取域名

var getDomainByUrl = function getDomainByUrl(inputUrl) {
  var url = inputUrl;
  url = url.replace(/(https|http)\:\/\//g, ''); // 去掉头部

  url = url.replace(/\/.*/, ''); // 去掉路径部分

  url = url.replace(/\?.*/, ''); // 去掉?部分

  url = url.replace(/\#.*/, ''); // 去掉hash部分

  return url;
}; // 生成domainKey，识别iframe  DOM


var getDomainKeyByUrl = function getDomainKeyByUrl(url) {
  var domain = getDomainByUrl(url);
  var domainKey = domainList[domain];

  if (!domainKey) {
    domainKey = "d".concat(Math.ceil(Math.random() * 1000000)); // eslint-disable-next-line no-restricted-syntax

    for (var k in domainList) {
      if (domainList[k] == domainKey) {
        domainKey = "d".concat(Math.ceil(Math.random() * 1000000));
        continue;
      }
    }

    domainList[domain] = domainKey;
  }

  return domainKey;
};
/*
    一个页面多个活动id，可能存在多个域名的ame请求，
    为了避免此问题，需要为每一个域名建立一个iframe通信机制
    add by marsboyding
    ============End==========
*/


var createXHRIframe = function createXHRIframe(url, id, callback) {
  var iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.id = id;
  iframe.width = 0;
  iframe.height = 0;
  iframe.frameborder = 0;
  iframe.style.border = '0';
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  if (iframe.attachEvent) {
    iframe.attachEvent('onload', callback);
  } else {
    iframe.onload = callback;
  }
};

var getXHRUrl = function getXHRUrl(data, amsActdesc, flowJsonData) {
  var objFlow = amsActdesc.flows["f_".concat(flowJsonData.iFlowId)];
  var sUrl;
  var xhrUrl;

  if (amsActdesc.sServiceType == 'cf') {
    sUrl = "".concat(location.protocol, "//cf.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3");
    xhrUrl = "".concat(location.protocol, "//cf.ams.game.qq.com");
  }

  if ((amsActdesc.sServiceDepartment == 'x1m1' || amsActdesc.sServiceDepartment == 'group_1') && amsActdesc.sServiceType != 'cf') {
    sUrl = "".concat(location.protocol, "//x1m1.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3");
    xhrUrl = "".concat(location.protocol, "//x1m1.ams.game.qq.com");
  }

  if (amsActdesc.sServiceDepartment == 'x6m5' || amsActdesc.sServiceDepartment == 'group_5') {
    sUrl = "".concat(location.protocol, "//x6m5.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3");
    xhrUrl = "".concat(location.protocol, "//x6m5.ams.game.qq.com");
  }

  if (amsActdesc.sServiceDepartment == 'x7' || amsActdesc.sServiceDepartment == 'group_6') {
    sUrl = "".concat(location.protocol, "//x7m3.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3");
    xhrUrl = "".concat(location.protocol, "//x7m3.ams.game.qq.com");
  } // 凡是X8M8 和 newterminals 业务的，在PC端的环境里，都走x8m8站点
  // 因 eagleyin(尹庆东) 08-01 17:26:11 需求修改


  if (amsActdesc.sServiceDepartment == 'x8' || amsActdesc.sServiceDepartment == 'newterminals' || amsActdesc.sServiceDepartment == 'group_b' || amsActdesc.sServiceDepartment == 'group_g') {
    sUrl = "".concat(location.protocol, "//x8m8.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3");
    xhrUrl = "".concat(location.protocol, "//x8m8.ams.game.qq.com");
  } // add by marsboyding ----start

  /* 2017.5.1大活动，如果活动id号大于临界值为yxzj和cfm走特殊处理*/


  if (amsActdesc.iActivityId >= 109733) {
    if ('yxzj' == amsActdesc.sServiceType || 110414 == flowJsonData.iActivityId) {
      // yxzj
      sUrl = "".concat(location.protocol, "//smoba.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3");
      xhrUrl = "".concat(location.protocol, "//") + 'smoba.ams.game.qq.com';
    } else if ('cfm' == amsActdesc.sServiceType) {
      // cfm
      sUrl = "".concat(location.protocol, "//cfm.ams.game.qq.com/ams/ame/ame.php?ameVersion=0.3");
      xhrUrl = "".concat(location.protocol, "//cfm.ams.game.qq.com");
    }
  } // ----end
  // add by marsboyding ----start

  /* 如果活动id号大于临界值且act.desc.js中有sAmePcUrl，则根据act.desc.js 决定请求服务器地址sUrl*/
  // 设置指定白名单活动，为了让老活动也可以走配置文件


  var ameConfigActReg = /^(53977|109144|11117|28054|104271)$/;

  if ((amsActdesc.iActivityId >= 109733 || ameConfigActReg.test(amsActdesc.iActivityId)
  /* yxzjPC这里的活动id号是一个临界值，用于判断是否是迭代后的新活动*/
  ) && amsActdesc.sAmePcUrl && 'string' === typeof amsActdesc.sAmePcUrl) {
    sUrl = "".concat(location.protocol, "//").concat(amsActdesc.sAmePcUrl, "?ameVersion=0.3");
    xhrUrl = "".concat(location.protocol, "//").concat(amsActdesc.sAmePcUrl.substring(0, amsActdesc.sAmePcUrl.indexOf('/')));
  } // ----end


  if (sUrl && xhrUrl) {
    sUrl += "&sServiceType=".concat(data.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sServiceDepartment);
  } else {
    sUrl = "".concat(location.protocol, "//apps.game.qq.com/ams/ame/ame.php?ameVersion=0.3&sServiceType=").concat(data.sServiceType, "&iActivityId=").concat(data.iActivityId, "&sServiceDepartment=").concat(data.sServiceDepartment, "&set_info=").concat(data.sServiceDepartment);
    xhrUrl = "".concat(location.protocol, "//apps.game.qq.com");
  }

  if (objFlow.isAnKeyPay == 1) {
    sUrl += "&isAmsPay=".concat(amsActdesc.sServiceType);
  } // add susahuang 2016/11/22


  if (typeof amsActdesc.sSDID !== 'undefined') {
    sUrl += "&sSDID=".concat(amsActdesc.sSDID);
  } // 增加sMiloTag参数作为请求唯一标识


  var arrMiloTag = ['AMS', 'MILO']; // 活动号

  if (flowJsonData.iActivityId) {
    arrMiloTag.push(flowJsonData.iActivityId);
  } else {
    var _path = location.href.replace(/(\?|\#).*/, '');

    _path = _path.replace(/(\:|\/|\.|\-)/g, '_');
    arrMiloTag.push(_path);
  } // 流程号：


  if (flowJsonData.iFlowId) {
    arrMiloTag.push(flowJsonData.iFlowId);
  } else {
    arrMiloTag.push('OTHER');
  } // uin或openid


  if (Cookie.get('acctype')) {
    arrMiloTag.push(Cookie.get('openid') || Cookie.get('uin') || 'unknown');
  } else {
    arrMiloTag.push(Cookie.get('uin') || Cookie.get('openid') || 'unknown');
  } // timestamp (ms)


  arrMiloTag.push(new Date().getTime()); // randomStr

  var sRandomMask = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var sRandomVal = '';

  for (var i = 0; i < 6; i++) {
    var rIndex = Math.floor(62 * Math.random());
    sRandomVal += sRandomMask.substr(rIndex, 1);
  }

  arrMiloTag.push(sRandomVal); // 放入url作为GET参数传过去

  sUrl += "&sMiloTag=".concat(arrMiloTag.join('-')); // EAS 上报活动号/流程号

  if (isObject(window.EAS)) {
    window.EAS.SendAmsLog(flowJsonData.iActivityId, flowJsonData.iFlowId);
  } // 方式区分代码


  sUrl += '&isXhrPost=true'; // 判断测试，预发布环境

  if ('test' == miloUrl.request('sAmsEnv')) {
    // test环境
    sUrl = sUrl.replace(/^https?\:\/\/([\w\-]+\.)+qq\.com/, "".concat(location.protocol, "//ame-test.odp.qq.com"));
    xhrUrl = xhrUrl.replace(/^https?\:\/\/([\w\-]+\.)+qq\.com/, "".concat(location.protocol, "//ame-test.odp.qq.com"));
  } else if ('pre' == miloUrl.request('sAmsEnv')) {
    // pre环境
    sUrl = sUrl.replace(/^https?\:\/\/([\w\-]+\.)+qq\.com/, "".concat(location.protocol, "//ame-pre.odp.qq.com"));
    xhrUrl = xhrUrl.replace(/^https?\:\/\/([\w\-]+\.)+qq\.com/, "".concat(location.protocol, "//ame-pre.odp.qq.com"));
  }

  return {
    xhrUrl: xhrUrl,
    sUrl: sUrl
  };
};

var postByIframe = function postByIframe(fl) {
  var amsActdesc = window["ams_actdesc_".concat(fl.flowJsonData.iActivityId)];
  var sData = fl.flowJsonData && fl.flowJsonData.sData || {};

  var _getXHRUrl = getXHRUrl(sData, amsActdesc, fl.flowJsonData),
      xhrUrl = _getXHRUrl.xhrUrl,
      sUrl = _getXHRUrl.sUrl; // eslint-disable-next-line no-param-reassign


  fl.sUrl = sUrl; // 存储对应关系

  sData.xhrPostKey = getXhrPostKey(); // 存储队列

  xhrPostQueue.push(sData); // 存储sUrl队列

  xhrPostUrlQueue.push(sUrl);
  xhrPostKeyCache[sData.xhrPostKey] = fl;
  var domainKey = getDomainKeyByUrl(xhrUrl);

  if (typeof window.postMessage === 'function') {
    return requestByPostMessage(xhrUrl, sUrl, domainKey);
  }

  return requestByPostData(xhrUrl, sUrl, domainKey);
};
/* 第一种形式：PostMessage*/


var requestByPostMessage = function requestByPostMessage(xhrUrl, sUrl, domainKey) {
  return new Promise(function (resolve, reject) {
    // message回调
    var onMessageFunc = function onMessageFunc(e) {
      if (e.origin == xhrUrl) {
        try {
          var objData = JSON.parse(e.data);
          var myFlow = xhrPostKeyCache[objData.callback]; // self.timeCostEnd(myFlow && myFlow.flowJsonData.iFlowId);

          if (200 == objData.status || 'undefined' === typeof objData.status) {
            // 耗时结束计时
            if (objData.data && objData.data.flowRet) {
              // 正常
              if (myFlow.sUrl == sUrl) {
                resolve(objData.data);
              }
            } else {
              // 返回数据有问题
              reject({
                statusCode: 200
              }); // alert("系统繁忙，请稍后再试");
              // 是否要上报。。。
              // if (Dialog.id == '_PopupMsg_') {
              // 	Dialog.hide();
              // }
            }
          } else {
            // 非200，服务器错误
            // 耗时结束计时
            // if (Dialog.id == '_PopupMsg_') {
            // 	Dialog.hide();
            // }
            reject({
              statusCode: objData.status,
              url: sUrl
            });
          }
        } catch (e) {
          reject({
            statusCode: -100
          });
        }
      }
    };

    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('message', function (e) {
        return onMessageFunc(e);
      }, false);
    } else if (typeof window.attachEvent !== 'undefined') {
      window.attachEvent('onmessage', function (e) {
        return onMessageFunc(e);
      });
    }

    var postByMessage = function postByMessage(xhrUrl) {
      for (var i = 0, len = xhrPostQueue.length; i < len; i++) {
        // 请求url必须和iframe的页面url保持一致，才能通信
        if (getDomainByUrl(xhrPostUrlQueue[i]) != getDomainByUrl(xhrUrl) || xhrPostQueue[i].sent) {
          continue;
        }

        g("amsPostMessageFrame_".concat(domainKey)).contentWindow.postMessage(['POST', xhrPostUrlQueue[i], MiloObject.serialize(xhrPostQueue[i]), MiloObject.serialize(xhrPostQueue[i].xhrPostKey)], '*');
        xhrPostQueue[i].sent = true;
      }

      var allSent = true;

      for (var j = 0; j < xhrPostQueue.length; j++) {
        if (!xhrPostQueue[j].sent) {
          allSent = false;
        }
      }

      if (allSent) {
        xhrPostQueue = [];
        xhrPostUrlQueue = [];
      }
    };

    if (!isDom(g("amsPostMessageFrame_".concat(domainKey)))) {
      createXHRIframe("".concat(xhrUrl, "/ams/postMessage_noflash.html"), "amsPostMessageFrame_".concat(domainKey), function () {
        // Post 环境ok
        xhrPostCondition = true; // 检查队列并执行

        if (isObject(xhrPostRelation)) {
          postByMessage(xhrUrl);
        }
      });
    } else {
      if (xhrPostCondition && xhrPostQueue && xhrPostQueue.length > 0) {
        postByMessage(xhrUrl);
      }
    }
  });
};
/* 第二种形式：postData，降域通信*/


var requestByPostData = function requestByPostData(xhrUrl, sUrl, domainKey) {
  return new Promise(function (resolve, reject) {
    var postDataFunc = function postDataFunc(postKey, callbackName) {
      // var myFlow=xhrPostKeyCache[postKey];
      window[callbackName] = {
        success: function success(str) {
          // 耗时结束计时
          // self.timeCostEnd(myFlow.flowJsonData.iFlowId);
          var objData = JSON.parse(str);

          if (objData.data && objData.data.flowRet) {
            // 正常
            resolve(objData.data);
          } else {
            // 返回数据有问题
            // alert("系统繁忙，请稍后再试");
            // 是否要上报。。。
            // if(Dialog.id == '_PopupMsg_'){
            // 	Dialog.hide();
            // }
            reject({
              statusCode: 200
            });
          }
        },
        failed: function failed(info) {
          reject({
            statusCode: info,
            url: sUrl
          }); // 上报非200错误
          // if(Dialog.id == '_PopupMsg_'){
          // 	Dialog.hide();
          // }
        }
      };
    };

    var postByData = function postByData() {
      for (var i = 0, len = xhrPostQueue.length; i < len; i++) {
        // 请求url必须和iframe的页面url保持一致，才能通信
        if (getDomainByUrl(xhrPostUrlQueue[i]) != getDomainByUrl(xhrUrl)) {
          continue;
        }

        var callbackName = "ams_opener_callback_".concat(Math.ceil(1000000 * Math.random()));
        postDataFunc(xhrPostQueue[i].xhrPostKey, callbackName);
        g("_amsOpenerFrame_".concat(domainKey)).contentWindow.postData('POST', xhrPostUrlQueue[i], MiloObject.serialize(xhrPostQueue[i]), callbackName);
        xhrPostQueue[i].sent = true;
      } // 删除已经post的元素


      var allSent = true;

      for (var j = 0; j < xhrPostQueue.length; j++) {
        if (!xhrPostQueue[j].sent) {
          allSent = false;
        }
      }

      if (allSent) {
        xhrPostQueue = [];
        xhrPostUrlQueue = [];
      }
    };

    if (!isDom(g("_amsOpenerFrame_".concat(domainKey)))) {
      createXHRIframe("".concat(xhrUrl, "/ams/opener_noflash.html"), "_amsOpenerFrame_".concat(domainKey), function () {
        // Post 环境ok
        xhrPostCondition = true;
        postByData();
      });
    } else {
      // 检查队列并执行
      if (xhrPostCondition && xhrPostQueue && xhrPostQueue.length > 0) {
        postByData();
      }
    }
  });
};

export default postByIframe;